// extracted by mini-css-extract-plugin
export default {"edit":"Passengers_edit__XAwqD","cancel":"Passengers_cancel__Qle7c"};